export default "https://cdn-static-staging.gokick.com/assets/8452366be4f72804419de7522b15e5b20c0c8dd8/images/choco-chill.d2e5a3cb4eac031c8a1d2dbef046a05a.png";